import type { AttachButton } from '../components/AttachToolbarButton';
import { logUsage } from 'owa-analytics';

export default function logAttachMenuData(defaultButtonsList: AttachButton[]) {
    // These are empty since we don't show attachment suggestions in calendar form.
    const endpoints: number[] = [];
    const ids: string[] = [];
    const ranks: number[] = [];
    const provenances: string[] = [];
    const fileTypes: string[] = [];

    logUsage('AttachButtonMenuOpened', [
        endpoints.join(','),
        ids.join(','),
        ranks.join(','),
        provenances.join(','),
        fileTypes.join(','),
        defaultButtonsList.join(','),
        false /* isMail */,
    ]);
}
